import {
  Backdrop,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getPaymentHostEventsDetails } from "../../../services/payment";
import { parseDate } from "../../../utils/tableFunctions";
import { Clear } from "@mui/icons-material";

const PaymentHostEventDetails = ({ itemId, isViewHistory }) => {
  const [hostDetails, sethostDetails] = useState();
  const [loaded, setLoaded] = useState();
  const { id = itemId } = useParams();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const action = useQuery().get("action") || (isViewHistory && "true");
  const mobile = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  useEffect(() => {
    getPaymentHostEventsDetails(id, sethostDetails, setLoaded);
  }, [action, id]);

  const handleBack = () => window.close();

  return (
    <Container>
      {!itemId && (
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Typography variant={mobile ? "h5" : "h3"}>
            Payment Host Details
          </Typography>

          <Button
            variant="outlined"
            onClick={handleBack}
            endIcon={<Clear />}
            sx={{ width: mobile ? "30%" : "15%" }}
          >
            Back
          </Button>
        </Stack>
      )}
      {loaded && action === "true" && (
        <Typography variant="h6" sx={{ mb: 2 }}>
          Action: {hostDetails.action && hostDetails.action}
        </Typography>
      )}
      {loaded ? (
        <Card sx={{ p: 3 }}>
          <Grid
            container
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 2, sm: 2, md: 2 }}
            sx={{ mt: 5 }}
          >
            <Grid item xs={6} md={6}>
              <Box
                sx={{
                  height: "100%",
                  p: 3,
                  border: "1px solid #999",
                  borderRadius: 2,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Created on</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {hostDetails.created_at
                      ? parseDate(hostDetails.created_at)
                      : "N/A"}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Created by</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {hostDetails.created_by
                      ? hostDetails.created_by.email
                      : "N/A"}
                  </Grid>
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={6} md={6}>
              <Box
                sx={{
                  height: "100%",
                  p: 3,
                  border: "1px solid #999",
                  borderRadius: 2,
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Payment Method</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {hostDetails.name}
                  </Grid>
                  <Grid item xs={6} md={5}>
                    <Typography variant="subtitle1">Action</Typography>
                  </Grid>
                  <Grid item xs={6} md={7}>
                    {hostDetails.action}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
          {hostDetails.reject_message && (
            <Typography variant="subtitle1" sx={{ mt: 2, display: "flex" }}>
              Reason for rejection:
              <Typography sx={{ ml: 1 }}>
                {" "}
                {hostDetails.reject_message}
              </Typography>
            </Typography>
          )}
          {hostDetails.action_message && (
            <Typography variant="subtitle1" sx={{ mt: 2, display: "flex" }}>
              Action message:
              <Typography sx={{ ml: 1 }}>
                {" "}
                {hostDetails.action_message}
              </Typography>
            </Typography>
          )}
        </Card>
      ) : (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Container>
  );
};

export default PaymentHostEventDetails;
